document.addEventListener('DOMContentLoaded', function () {
  var requested = new URLSearchParams(window.location.search).get('gs_product');
  if (requested) { var target = document.getElementById('shop-' + requested); if (target) target.scrollIntoView({block:'start'}); }
  document.querySelectorAll('[data-shop-card]').forEach(function (card) {
    var select = card.querySelector('[data-shop-variant]');
    var quantity = card.querySelector('[data-shop-quantity]');
    var money = function (pence) { return new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(pence / 100); };
    var update = function () {
      var option = select.selectedOptions[0];
      var pack = Number(option.dataset.pack);
      var price = Number(option.dataset.price);
      var included = card.dataset.taxesIncluded === 'true';
      var net = included ? Math.round(price / 1.2) : price;
      var available = option.dataset.available === 'true';
      card.querySelector('[data-shop-net]').textContent = money(net);
      card.querySelector('[data-shop-gross]').textContent = money(included ? price : Math.round(price * 1.2)) + ' inc VAT';
      card.querySelector('[data-shop-unit]').textContent = money(Math.round(net / pack)) + ' ex VAT per screw';
      card.querySelector('[data-shop-pack-label]').textContent = pack === 1 ? '/ screw' : '/ cage';
      card.querySelector('[data-shop-quantity-label]').textContent = pack === 1 ? 'Number of screws' : 'Number of cages';
      var count = Math.max(1, Math.floor(Number(quantity.value) || 1));
      card.querySelector('[data-shop-total]').textContent = money(net * count);
      card.querySelector('[data-shop-count]').textContent = (count * pack).toLocaleString('en-GB') + (count * pack === 1 ? ' screw' : ' screws');
      var button = card.querySelector('[data-shop-add]');
      button.disabled = !available;
      button.textContent = available ? 'ADD TO BASKET' : 'AWAITING STOCK';
      card.querySelector('[data-shop-stock]').textContent = available ? 'Available to order' : 'Not currently available to buy';
    };
    select.addEventListener('change', update);
    quantity.addEventListener('input', update);
    update();
  });
});
